//
//
//
//

export default {
  name: 'badge',
  props: {
    text: [String, Number]
  }
}
